import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCompanyStore } from 'stores';
// api
import { getHelpTextId } from 'api/company';
// images
import Compras from 'assets/img/img_como_comprar.png';
// components
import Head from 'components/metatags_helmet/metatags';
import './infoPages.scss';

const HelpText = () => {
  let { id, slug } = useParams();
  const { descripcion_pub } = useCompanyStore();
  const [helpTextDetails, setHelpTextDetails] = useState(null);
  const { i18n } = useTranslation();  
  const currentLang = i18n.language;

  useEffect(() => {
    const fetchHelpTextDetails = async () => {
      try {
        let response;
        if (id) {
          response = await getHelpTextId(id);
        } else if (slug) {
          response = await getHelpTextId(slug);
        }
        setHelpTextDetails(response.data);
      } catch (error) {
        console.error('Error fetching help text details:', error);
      }
    };
    fetchHelpTextDetails();
  }, [id, slug]);

  if (!helpTextDetails) {
    return <div>Cargando...</div>;
  }

  const localizedTitle = helpTextDetails[`title_${currentLang}`] || helpTextDetails.title;
  const localizedText = helpTextDetails[`text_${currentLang}`] || helpTextDetails.text;

  return (
    <div className="container-fluid px-0 mainDiv">
      <Head description={descripcion_pub} title={localizedTitle} noIndex={true} />
      <Row className="justify-content-center mainRow infoRow px-0">
        <Col xs={11} lg={8} className="mt-4 pl-0">
          <div className="row">
            <div className="col-md-12">
              <h1 className="page-title static-title">{localizedTitle}</h1>
            </div>
          </div>

          <div dangerouslySetInnerHTML={{ __html: localizedText }}></div>
        </Col>
        <Col xs={3} lg={3} className="d-flex justify-content-center align-items-start mt-4 pr-0 pt-lg-4">
          <img src={Compras} alt="buy.png" className="infoImg" />
        </Col>
      </Row>
    </div>
  );
};

export default HelpText;
